import React, { forwardRef, memo, ReactNode } from 'react'
import styles from './Image.module.sass'
import { FileData, isFileData, isImage } from '../../../../responses/files'
import { ROUTES } from '../../../../http/routes'
import clsx from 'clsx'
import { defaultStyles, FileIcon } from 'react-file-icon'
import { urlWithParams } from '../../../../http/utils'
import { splitFileName } from '../../../../utils/utils'

export interface ImageProps {
    className?: string,
    file: File | FileData,
    onClick?: (event: React.MouseEvent) => void,
    objectFit?: 'cover' | 'fill' | 'contain' | 'none' | 'scale-down',
    size?: ImageSize,
    objectPosition?: string,
    children?: ReactNode,
}

export type ImageSize = 'low' | 'medium' | 'high'

const Image = forwardRef<HTMLDivElement, ImageProps>((props, ref) => {
    const [name, extension] = splitFileName(props.file.name)

    return <div
        ref={ref}
        className={clsx(props.className, styles.image, {
            [styles.interactive]: props.onClick,
        })}
        onClick={props.onClick}
    >
        {
            isFileData(props.file) && isImage(props.file) ?
                <img
                    alt={name}
                    src={urlWithParams({ filename: props.file.filename, size: props.size ?? 'medium' })(ROUTES.FILE_PREVIEW)}
                    style={{
                        objectFit: props.objectFit,
                        objectPosition: props.objectPosition,
                    }}
                /> :
                <FileIcon
                    labelUppercase
                    extension={extension}
                    {...defaultStyles[extension]}
                />
        }
        {
            props.children
        }
    </div>
})

Image.displayName = 'Image'

export default memo(Image)